import React from 'react'
import QSComponent from '../SaiaLtl/QuoteSettingsComponent'

const QuoteSettingsComponent = () => <QSComponent carr = 'daylight-ltl'/>

export default QuoteSettingsComponent
